import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"

const copy: DefaultSectionCopy = {
  type: Section.CUSTOMERS,
  name: "Customers",
  base: "customers",
  routes: [],
  buttons: [
    { name: COPY_KEYS.BUTTONS.CREATE, label: "Create Customer", description: "Add a new customer to the system" },
    { name: COPY_KEYS.BUTTONS.FILTER, label: "Filter", description: "Filter customers" },
    {
      name: COPY_KEYS.BUTTONS.ARCHIVE,
      label: "Delete this customer",
      description: "Delete the current customer",
    },
    { name: COPY_KEYS.BUTTONS.EDIT, label: "Edit", description: "Edit customer" },
    { name: COPY_KEYS.BUTTONS.SAVE, label: "Save", description: "Save changes" },
    {
      name: COPY_KEYS.BUTTONS.CANCEL,
      label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.CANCEL],
      description: "Cancel changes",
    },
  ],
  headings: [
    { name: COPY_KEYS.HEADINGS.TIMESTAMP, value: "Timestamp" },
    { name: COPY_KEYS.HEADINGS.NAME, value: "Customer Name" },
    { name: COPY_KEYS.HEADINGS.CUSTOMER, value: "Customer" },
    { name: COPY_KEYS.HEADINGS.SITE, value: "Sites" },
    { name: COPY_KEYS.HEADINGS.SITES, value: "Site(s)" },
    { name: COPY_KEYS.HEADINGS.ASSET, value: "Assets" },
    { name: COPY_KEYS.HEADINGS.ASSETS, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSETS] },
    { name: COPY_KEYS.HEADINGS.RUN_DRY, value: "Run Dry (earliest)" },
    { name: COPY_KEYS.HEADINGS.USAGE, value: "Total hydrogen usage" },
    { name: COPY_KEYS.HEADINGS.ACTIONS, value: "Actions" },
    { name: COPY_KEYS.HEADINGS.NOTE, value: "Note" },
    { name: COPY_KEYS.HEADINGS.CURRENT_ORDER, value: "Current Order" },
    { name: COPY_KEYS.HEADINGS.ORDER, value: "Order" },
    { name: COPY_KEYS.HEADINGS.ORDERS, value: "Orders" },
    { name: COPY_KEYS.HEADINGS.INFORMATION, value: "Information" },
    // Messages
    { name: COPY_KEYS.MESSAGES.CREATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATED] },
    { name: COPY_KEYS.MESSAGES.UPDATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATED] },
    { name: COPY_KEYS.MESSAGES.DELETED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.DELETED] },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED],
    },
    { name: COPY_KEYS.MESSAGES.CREATION_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATION_FAILED] },
    { name: COPY_KEYS.MESSAGES.UPDATE_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATE_FAILED] },
    { name: COPY_KEYS.MESSAGES.VALIDATION_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.VALIDATION_ERROR] },
    { name: COPY_KEYS.MESSAGES.UNEXPECTED_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UNEXPECTED_ERROR] },
    {
      name: COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME],
    },
    { name: COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM] },
    {
      name: COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM],
    },
    // Forms
    { name: COPY_KEYS.FORMS.PLEASE_PROVIDE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_PROVIDE] },
    { name: COPY_KEYS.FORMS.PLEASE_SELECT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_SELECT] },
    { name: COPY_KEYS.FORMS.ENTER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.ENTER] },
    { name: COPY_KEYS.FORMS.INFORMATION_BELOW, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.INFORMATION_BELOW] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_CREATE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_CREATE] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_EDIT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_EDIT] },
    {
      name: COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME],
    },
    // Labels
    { name: COPY_KEYS.LABELS.NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.NAME] },
    { name: COPY_KEYS.LABELS.CUSTOMER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.CUSTOMER] },
    { name: COPY_KEYS.LABELS.SITE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.SITE] },
    { name: COPY_KEYS.LABELS.SITE_NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.SITE_NAME] },
    // Actions
    { name: COPY_KEYS.ACTIONS.CREATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.CREATING] },
    { name: COPY_KEYS.ACTIONS.UPDATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.UPDATING] },
    { name: COPY_KEYS.ACTIONS.DELETING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.DELETING] },
    // Common
    { name: COPY_KEYS.COMMON.A, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.A] },
    { name: COPY_KEYS.COMMON.AN, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AN] },
    { name: COPY_KEYS.COMMON.THE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.THE] },
    { name: COPY_KEYS.COMMON.AND, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AND] },
    { name: COPY_KEYS.COMMON.TO_THE_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.TO_THE_SYSTEM] },
  ],
  statuses: [],
}

// const fleet: DefaultSectionCopy = {
//   type: Section.CUSTOMERS,
//   name: "Fleets",
//   base: "fleets",
//   routes: [],
//   buttons: [
//     { name: COPY_KEYS.BUTTONS.CREATE, label: "Create fleet", description: "Add a new fleet to the system" },
//     { name: COPY_KEYS.BUTTONS.FILTER, label: "Filter", description: "Filter fleets" },
//   ],
//   headings: [
//     { name: COPY_KEYS.HEADINGS.TIMESTAMP, value: "Timestamp" },
//     { name: COPY_KEYS.HEADINGS.NAME, value: "Fleet Name" },
//     { name: COPY_KEYS.HEADINGS.SITE, value: "Zone" },
//     { name: COPY_KEYS.HEADINGS.ASSET, value: "Vehicle" },
//     { name: COPY_KEYS.HEADINGS.ASSET_NAME, value: "Vehicle Name" },
//     { name: COPY_KEYS.HEADINGS.SITES, value: "Zone(s)" },
//     { name: COPY_KEYS.HEADINGS.ASSETS, value: "Vehicle(s)" },
//     { name: COPY_KEYS.HEADINGS.RUN_DRY, value: "Run Dry (earliest)" },
//     { name: COPY_KEYS.HEADINGS.USAGE, value: "Total hydrogen usage" },
//     { name: COPY_KEYS.HEADINGS.ACTIONS, value: "Actions" },
//     { name: COPY_KEYS.HEADINGS.NOTE, value: "Note" },
//   ],
// }

export default copy
